import React from 'react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

const Navbar = ({ changeLanguage, toggleDarkMode, darkMode }) => {
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState('en');

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'de' : 'en';
    setCurrentLanguage(newLanguage);
    changeLanguage(newLanguage);
  };

  return (
    <nav className="fixed top-0 z-50 w-full h-16 shadow-md bg-background">
      <div className="container px-4 mx-auto">
        <div className="flex justify-between items-center py-4">
          {/* Left Section (Logo/Portfolio) */}
          <div className="flex items-center">
            {/* Hamburger icon */}
            <button className="p-2 md:hidden">
              <span className="block mb-1 w-6 h-0.5 bg-secondary"></span>
              <span className="block mb-1 w-6 h-0.5 bg-secondary"></span>
              <span className="block w-6 h-0.5 bg-secondary"></span>
            </button>
            {/* Logo */}
            <a href="#" className="flex-shrink-0 ml-4 font-bold textx1 md:text-2xl text-primary">
              JOHN LINTHICUM
            </a>
          </div>

          {/* Middle Section (Links) */}
          <div className="hidden px-8 ml-auto space-x-4 text-2xl font-semibold md:flex lg:space-x-8">
            <a href="#about" className="text-primary hover:text-secondary">
              {t('about')}
            </a>
            <a href="#projects" className="text-primary hover:text-secondary">
              {t('projects')}
            </a>
            <a href="#resume" className="text-primary hover:text-secondary">
              {t('resume')}
            </a>
            <a href="#contact" className="text-primary hover:text-secondary">
              {t('contact')}
            </a>
          </div>

          {/* Right Section (Language and Dark Mode Toggles) */}
          <div className="flex items-center space-x-8">
            {/* Language Toggle Button */}
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 focus:outline-none"
            >
              <img
                src={
                  currentLanguage === 'en'
                    ? 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg'
                    : 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg'
                }
                alt={currentLanguage === 'en' ? 'English' : 'German'}
                className="w-6 h-6"
              />
            </button>

            {/* Dark Mode Toggle */}
      <button
        className="text-primary"
        onClick={toggleDarkMode}
      >
        {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
      </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
